export const pattern = ['Nexen N’ Fera SU1', 'Nexen N’ Fera RU1']
